import React, { useMemo } from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';

import { Collapse, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import type { IInvoiceItem } from 'v2/components/Pages/Orders/interfaces';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import ordersService from 'v2/services/orders';

const HiddenValue = ({ value }: { value: number }) => (
  <>
    <PermissionHide inverse action='myeduzz:minhas-entregas:ocultar-valores'>
      <FormattedNumber format='BRL' value={value} />
    </PermissionHide>
    <PermissionHide inverse={false} action='myeduzz:minhas-entregas:ocultar-valores'>
      <em>oculto</em>
    </PermissionHide>
  </>
);

const InvoiceItems = () => {
  useObservable(() => ordersService.loadInvoiceItems(), []);
  const [isLoading] = useObservable(() => ordersService.isLoadingInvoiceItems(), []);
  const [invoiceItems] = useObservable(() => ordersService.getInvoiceItems(), []);

  const columns = useMemo(
    (): ColumnsType<IInvoiceItem> => [
      { key: 'content', title: 'Conteúdo', render: (_, item) => `${item.id} - ${item.description}` },
      { key: 'units', title: 'Qtd.', dataIndex: 'units' },
      { key: 'unitary_value', title: 'Un.', render: (_, item) => <HiddenValue value={item.unitary_value} /> },
      { key: 'amount', title: 'Total', render: (_, item) => <HiddenValue value={item.amount} /> }
    ],
    []
  );

  return (
    <Collapse>
      <Collapse.Panel key='invoice-items' header='Itens do pedido' className='[&_.ant-collapse-content-box]:p-0!'>
        <Table
          size='small'
          columns={columns}
          dataSource={Array.isArray(invoiceItems) ? invoiceItems : []}
          rowKey='id'
          loading={isLoading}
          pagination={false}
          locale={{ emptyText: 'Nenhum item encontrado...' }}
        />
      </Collapse.Panel>
    </Collapse>
  );
};
export default InvoiceItems;
